import { render, staticRenderFns } from "./BaseCardContainer.vue?vue&type=template&id=6144cb4c"
import script from "./BaseCardContainer.vue?vue&type=script&lang=ts"
export * from "./BaseCardContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports